import { render, staticRenderFns } from "./environment-text.vue?vue&type=template&id=6bd80100&"
import script from "./environment-text.vue?vue&type=script&lang=js&"
export * from "./environment-text.vue?vue&type=script&lang=js&"
import style0 from "./environment-text.vue?vue&type=style&index=0&id=6bd80100&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports